import CRUD from 'src/store/models/helper/CRUD.js'
import Timetable from 'src/api/timetable.js'
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

const findExactHour = (l, hour) => {
  return hour.time_begins_at === l.time_begins_at &&
    hour.time_ends_at === l.time_ends_at
}

const findWrappingHour = (l, { timeBeginsAt, timeEndsAt }) => {
  return timeBeginsAt <= l.time_begins_at &&
    timeEndsAt >= l.time_ends_at
}
export class Time extends CRUD {
  static entity = 'times'
  static fetchUrl = Timetable.timetableTimesUrl()

  static fields () {
    return {
      id: this.attr(null),
      begins_at: this.attr(null),
      ends_at: this.attr(null),
      hour: this.number(0),
      shortcut: this.number(null),
      name: this.string(null).nullable(),
      type: this.string('LESSON'), // todo: add enum here
      is_hidden: this.boolean(false),
      time_begins_at: this.number(0),
      time_ends_at: this.number(0),
      meta: this.attr({})
    }
  }

  static beforeCreate (model) {
    model.time_begins_at = model.time_begins_at || GlobalPrototypes.moment(model.begins_at).unix()
    model.time_ends_at = model.time_ends_at || GlobalPrototypes.moment(model.ends_at).unix()
    model.shortcut = model.shortcut || model.hour
  }

  get begins_atMoment () {
    if (!this.begins_at) return
    // timetable gives as unix (e.g. 25200) back, while sdui-planner gives us a string (e.g. 1970-01-01T07:00:00.000Z)
    return (typeof this.begins_at === 'number') ? GlobalPrototypes.moment.utc(GlobalPrototypes.moment.unix(this.begins_at)).local() : GlobalPrototypes.moment(this.begins_at)
  }

  get ends_atMoment () {
    if (!this.ends_at) return
    // timetable gives as unix (e.g. 25200) back, while sdui-planner gives us a string (e.g. 1970-01-01T07:00:00.000Z)
    return (typeof this.ends_at === 'number') ? GlobalPrototypes.moment.utc(GlobalPrototypes.moment.unix(this.ends_at)).local() : GlobalPrototypes.moment(this.ends_at)
  }

  static findTime (lesson, { matchInside } = { matchInside: true }) {
    return this.all().find(hour => findExactHour(lesson, hour)) ||
      (matchInside && this.all().find(hour => findWrappingHour(lesson, hour)))
  }
}

export default Time
